import React, { useState, useEffect } from "react";
import UserModalItem from "../items/user_modal_item";
import { Link, useNavigate } from "react-router-dom";
import { t } from "i18next";
import monitoringService from "../../../../services/monitoringService";
import { getUserInfo } from "../../../../api/usercall";

function ModalList() {
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [userInfo, setUserInfo] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUserInfo = async () => {
            try {
                const data = await getUserInfo();
                if (data?.user) {
                    setUserInfo(data.user);
                }
            } catch (err) {
                console.error("Failed to fetch user info", err);
            }
        };
        fetchUserInfo();
    }, []);

    const isDealer = userInfo?.user_type === "dealer";

    const handleLogout = async () => {
        await monitoringService.trackLogout().catch(() => {});
        localStorage.clear();
        navigate("/sign");
    };

    return (
        <>
            <div className="flex flex-col gap-0.5">
                {isDealer && (
                    <Link to="/profile#myOrders" className="no-underline">
                        <UserModalItem iconPath="order" itemName={t('myOrders')} />
                    </Link>
                )}
                <Link to="/profile#ads" className="no-underline">
                    <UserModalItem iconPath="note" itemName={t('announcements')} />
                </Link>
                <Link to="/profile#messages" className="no-underline">
                    <UserModalItem iconPath="chat" itemName={t('messages')} />
                </Link>
                <Link to="/profile#favorites" className="no-underline">
                    <UserModalItem iconPath="heart" itemName={t('favorites')} />
                </Link>
                <Link to="/profile#settings" className="no-underline">
                    <UserModalItem iconPath="gear" itemName={t('settings')} />
                </Link>
                <div className="border-t border-[#F0F0F0] my-1" />
                <div onClick={() => setShowLogoutModal(true)}>
                    <UserModalItem iconPath="signout" itemName={t('logout')} danger />
                </div>
            </div>

            {showLogoutModal && (
                <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/40 backdrop-blur-sm">
                    <div className="bg-white rounded-2xl p-6 w-[320px] flex flex-col items-center gap-4 shadow-xl">
                        <div className="w-12 h-12 rounded-2xl bg-red-50 flex items-center justify-center text-2xl">
                            👋
                        </div>
                        <h2 className="m-0 text-[16px] font-bold text-[#222] text-center">
                            {t('logoutPrompt')}
                        </h2>
                        <div className="flex gap-3 w-full">
                            <button
                                onClick={() => setShowLogoutModal(false)}
                                className="flex-1 h-11 rounded-xl border border-[#EDEDED] bg-[#F5F5F5] text-[14px] font-medium text-[#555] cursor-pointer hover:bg-[#EBEBEB] transition-colors"
                            >
                                {t('no')}
                            </button>
                            <button
                                onClick={handleLogout}
                                className="flex-1 h-11 rounded-xl border-none bg-red-500 text-[14px] font-semibold text-white cursor-pointer hover:bg-red-600 transition-colors"
                            >
                                {t('yes')}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default ModalList;
